export const typeExtraResource = {
	assets: "ASSETS",
	provider: "PROVEDOR",
	serviceWeb: "SERVIDOR",
};

export const typeAssets = [
	{
		name: "Asset 3D",
		father: typeExtraResource.assets,
	},
	{
		name: "Plug In",
		father: typeExtraResource.assets,
	},
	{
		name: "Asset 2D",
		father: typeExtraResource.assets,
	},
	{
		name: "Otro",
		father: typeExtraResource.assets,
	},
];
export const typeServiceWeb = [
	{
		name: "Hosting",
		father: typeExtraResource.serviceWeb,
	},
	{
		name: "Mailing",
		father: typeExtraResource.serviceWeb,
	},
	{
		name: "Dominio",
		father: typeExtraResource.serviceWeb,
	},
	{
		name: "Base de Datos",
		father: typeExtraResource.serviceWeb,
	},
	{
		name: "Bucket",
		father: typeExtraResource.serviceWeb,
	},
	{
		name: "Otro",
		father: typeExtraResource.serviceWeb,
	},
];
export const typeProvedor = [
	{
		name: "Diseño UI/UX",
		father: typeExtraResource.provider,
	},
	{
		name: "Arte 3D",
		father: typeExtraResource.provider,
	},
	{
		name: "Programación Unity",
		father: typeExtraResource.provider,
	},
	{
		name: "Programación Web",
		father: typeExtraResource.provider,
	},
	{
		name: "Video / Foto",
		father: typeExtraResource.provider,
	},
	{
		name: "Streaming",
		father: typeExtraResource.provider,
	},
	{
		name: "QA",
		father: typeExtraResource.provider,
	},
	{
		name: "Locución / Audio",
		father: typeExtraResource.provider,
	},
	{
		name: "Traductor",
		father: typeExtraResource.provider,
	},
	{
		name: "Otro",
		father: typeExtraResource.provider,
	},
];

export const joinArrayServices = () => {
	return [].concat(typeAssets, typeServiceWeb, typeProvedor);
};
